import React from "react";
import { Eye, FileEdit, ArrowDownToLine, Trash2 } from "lucide-react";
import CustomTable from "Common/Components/CustomTable";
import { BulkAction, Column } from "Common/Components/CustomTable/types";
import FieldCreateModal from "./components/Modal/Create";
import FieldsData from "./components/tabledata";
import { useAppServices } from "hook/services";
import Swal from "sweetalert2";

const Fields: React.FC = () => {
  const AppService = useAppServices();
  const { 
    columns, 
    fields, 
    loading, 
    EditModel, 
    handleRefresh, 
    folders,
    currentPage, 
    totalPages, 
    totalItems,
    handlePageChange 
  } = FieldsData();

  const handleBulkAction = async (type: "delete" | "update", selectedIds: any[]) => {
    if (selectedIds.length === 0) return;

    if (type === "delete") {
      const result = await Swal.fire({
        title: "Are you sure?",
        text: `You are about to delete ${selectedIds.length} Field(s). This action cannot be undone.`,
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#ef4444",
        cancelButtonColor: "#6b7280",
        confirmButtonText: "Yes, Delete!",
      });

      if (!result.isConfirmed) return;
    }

    try {
      const payload = {
        type,
        selectedIds: selectedIds,
      };
      const { response, error } = await AppService.custom_field.field.bulk_action({
        payload,
        toaster: true,
      });

      if (error) throw new Error(error.message || "Bulk action failed");

      handleRefresh();
    } catch (err: any) {}
  };

  const bulkActions: BulkAction[] = [
    {
      label: "Delete",
      action: (selectedIds: (string | number)[]) => {
        handleBulkAction("delete", selectedIds);
      },
      icon: <Trash2 className="size-3" />,
      variant: "danger",
    },
  ];

  return (
    <React.Fragment>
      <div className="flex items-center gap-3 mb-4">
        <h5 className="underline grow">Fields</h5>
        <div className="shrink-0">
          {EditModel}
          <FieldCreateModal handleRefresh={handleRefresh} folders={folders} />
        </div>
      </div>

      <CustomTable
        columns={columns}
        data={fields}
        keyField="_id"
        searchable={true}
        searchFields={["name"]}
        searchPlaceholder="Search by name..."
        sortable={false} // Disable client-side sorting when using server-side pagination
        bulkActions={bulkActions}
        selectable={true}
        pagination={true}
        itemsPerPage={10} // Changed from 3 to 10 for consistency
        // Server-side pagination props
        currentPage={currentPage}
        totalPages={totalPages}
        totalItems={totalItems}
        onPageChange={handlePageChange}
        loading={loading}
      />
    </React.Fragment>
  );
};

export default Fields;